(function () {
  'use strict';

  var MODAL_CLASS = 'feedback-survey-modal';
  var OPEN_CLASS = 'is-open';
  var PLACEHOLDER_HTML = '<p class="feedback-survey-modal__loading">Survey laden...</p>';

  function activateScripts(container) {
    // innerHTML and <template> clones do not execute <script> tags.
    // Replace each with a fresh element so the browser runs it.
    // Handle two Cookiebot scenarios:
    //   1. Script untouched - we add data-cookieconsent="necessary" so the
    //      MutationObserver does not block on append.
    //   2. Script already neutered by Cookiebot at parse time (template-
    //      scripts get rewritten to type="text/plain" + data-cookieblock-src)
    //      - we recover the original src and strip the type override.
    // Rationale: user opened the feedback modal explicitly => implicit
    // consent for this interaction.
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attr) {
        newScript.setAttribute(attr.name, attr.value);
      });

      var blockedSrc = oldScript.getAttribute('data-cookieblock-src');
      if (blockedSrc) {
        newScript.setAttribute('src', blockedSrc);
        newScript.removeAttribute('data-cookieblock-src');
      }
      if ((newScript.getAttribute('type') || '').toLowerCase() === 'text/plain') {
        newScript.removeAttribute('type');
      }

      if (!newScript.hasAttribute('data-cookieconsent')) {
        newScript.setAttribute('data-cookieconsent', 'necessary');
      }

      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root) return;

    var yesModal = document.getElementById(sectionId + '-modal-yes');
    var noModal = document.getElementById(sectionId + '-modal-no');
    var modals = { yes: yesModal, no: noModal };
    var lastFocused = null;
    var surveysLoaded = { yes: false, no: false };
    var surveyHTML = { yes: '', no: '' };

    Object.keys(modals).forEach(function (which) {
      var m = modals[which];
      if (!m) return;
      var tpl = m.querySelector('template[data-survey]');
      if (tpl) surveyHTML[which] = tpl.innerHTML;
    });

    [yesModal, noModal].forEach(function (m) {
      if (m && m.parentElement !== document.body) {
        document.body.appendChild(m);
      }
    });

    function resetSurvey(which) {
      var modal = modals[which];
      if (!modal) return;
      var body = modal.querySelector('.' + MODAL_CLASS + '__body');
      if (!body) return;
      body.innerHTML = PLACEHOLDER_HTML;
      surveysLoaded[which] = false;
    }

    function loadSurvey(which) {
      var modal = modals[which];
      if (!modal || !surveyHTML[which]) return;

      var other = which === 'yes' ? 'no' : 'yes';
      if (surveysLoaded[other]) resetSurvey(other);

      if (surveysLoaded[which]) return;

      var body = modal.querySelector('.' + MODAL_CLASS + '__body');
      if (!body) return;

      body.innerHTML = surveyHTML[which];
      activateScripts(body);
      surveysLoaded[which] = true;
    }

    function openModal(which) {
      var modal = modals[which];
      if (!modal) return;

      lastFocused = document.activeElement;
      loadSurvey(which);

      modal.classList.add(OPEN_CLASS);
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      var focusTarget = modal.querySelector('.' + MODAL_CLASS + '__x');
      if (focusTarget) focusTarget.focus();
    }

    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove(OPEN_CLASS);
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';

      if (lastFocused && lastFocused.focus) lastFocused.focus();
      lastFocused = null;
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-feedback-open]');
      if (btn) openModal(btn.getAttribute('data-feedback-open'));
    });

    [yesModal, noModal].forEach(function (modal) {
      if (!modal) return;
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-feedback-close]')) closeModal(modal);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.' + MODAL_CLASS + '.' + OPEN_CLASS);
      if (open) closeModal(open);
    });
  }

  document.querySelectorAll('[data-feedback-survey]').forEach(function (el) {
    init(el.id);
  });
})();
